import React from 'react';
// styles
import styled from 'styled-components';

const CheckCircleFullIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Check circle full"
    className={className}
    role="img"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9.5" fill="white" stroke="#CCD6E0" />
    <path
      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9969 7.34878 18.9424 4.80704 17.0677 2.93234C15.193 1.05765 12.6512 0.00308769 10 0ZM15.7725 6.83333L10.0683 14.5742C10.001 14.6635 9.91653 14.7386 9.81987 14.7949C9.72321 14.8513 9.61629 14.8878 9.50536 14.9024C9.39442 14.917 9.2817 14.9093 9.17376 14.8799C9.06581 14.8504 8.96482 14.7997 8.87667 14.7308L4.80334 11.4742C4.71787 11.4058 4.64671 11.3212 4.59392 11.2253C4.54113 11.1294 4.50775 11.0241 4.49568 10.9153C4.4713 10.6955 4.5352 10.4751 4.67334 10.3025C4.81147 10.1299 5.01252 10.0192 5.23225 9.99484C5.45198 9.97046 5.67239 10.0344 5.845 10.1725L9.24167 12.89L14.4308 5.8475C14.4933 5.75376 14.5741 5.67365 14.6684 5.61203C14.7627 5.5504 14.8686 5.50854 14.9795 5.48897C15.0904 5.46939 15.2042 5.47251 15.3139 5.49814C15.4236 5.52377 15.527 5.57138 15.6177 5.63808C15.7085 5.70479 15.7848 5.7892 15.8421 5.88623C15.8993 5.98326 15.9363 6.09089 15.9507 6.20261C15.9652 6.31433 15.9569 6.42782 15.9262 6.53623C15.8956 6.64464 15.8433 6.74571 15.7725 6.83333Z"
      fill="#0140CD"
    />
  </svg>
);

export default styled(CheckCircleFullIcon)``;
